import { apiClient } from "lib/apiClient";
import {
  IResearchNoteRequest,
  IResearchWorkItem,
} from "features/Research/types";

export const addResearchWorkItemNote = async (
  workItemId: string,
  request: IResearchNoteRequest
): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/notes`,
    request
  );
  return response.data;
};
